import { observer } from "mobx-react";
import * as React from "react";

import { ListUserProductivity } from "../ui/molecules/list-user-productivity";
import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageUserProductivity extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[
                    articles.operatorTeamProductivityReport,
                    articles.downloadDocuments,
                ]}
                breadcrumb={store.i18n.t("page.userProductivity.title")}
            >
                <Section fill>
                    <ListUserProductivity
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
